// Statystyki — piąta zakładka Publikacji (sesja 36, artboardy 01–05c). Klucze trzymaj
// zgodne z en/appStats.ts.
//
// RAMA COPY. Ekran jest EKRANEM FAKTÓW: liczby WŁASNYCH postów właściciela konta,
// prosto z oficjalnych API platform. Nie ma tu ani jednego porównania („lepiej niż”),
// prognozy („będzie”), rady („opublikuj o”) ani liczby cudzej. Nie ma też akcji
// wypełnionej: niczego się stąd nie zmienia.
//
// ZASADA 8. Zdania, które tłumaczyły liczby, zastąpiły pigułki: „jeszcze bez liczb”
// (post świeży), „nieaktualne” (liczby starsze niż dwa cykle synchronizacji konta),
// „zaloguj ponownie” (to samo słowo, co w zakładce Konta). Etykieta „co 2-3 dni”
// zastąpiła zdanie o cyklu YouTube. Łącznik ASCII, nigdy półpauza (reguła repo).
//
// SŁOWNIK ZAKAZANY. Pierwszy licznik nazywa się „Obejrzenia” (PL) i „Plays” (EN), bo
// nazwy platform („wyświetlenia”, „odtworzenia”, „views”) są słowami, których produkt
// nie wypowiada w ŻADNYM locale (`scripts/forbidden_vocab_lint.py`, reguła 4). MAPA 36
// proponowała dla tego jednego klucza zakresowy wyjątek lintu; wyjątku nie zakładamy —
// to decyzja właściciela bramki, nie paczki implementacyjnej.
export const appStats = {
  // Przełącznik zakresu; wartość zostaje widoczna także wtedy, gdy kontrolka jest nieaktywna.
  range: {
    label: 'Zakres statystyk',
    d7: '7 dni',
    d30: '30 dni',
    all: 'Wszystko',
  },
  // Pas pigułek platform (36-R4) stoi OSOBNO od filtra konta; konto zawęża się do
  // wybranej platformy. „Wszystko” zdejmuje filtr.
  platform: {
    label: 'Platforma',
    all: 'Wszystko',
  },
  filter: {
    all: 'Wszystkie konta',
    title: 'Konto',
    label: 'Konto, którego dotyczą liczby',
  },
  // Nazwa szeregu liczby osób na koncie. ROBOCZA: decyzja właściciela czeka, a
  // propozycje (Widownia · Odbiorcy · Publiczność) poszły do niego w kwicie paczki ST.
  // Jeden klucz w PL i EN, żeby zmiana po decyzji była jedną linią (rozstrzygnięcie 6
  // koordynatora, brief paczek K · ST · P · I).
  series: {
    audience: 'Społeczność',
  },
  // Karta wykresu: wybór szeregu, jednostka, odczyt dnia i tabela dla czytnika ekranu.
  chart: {
    title: 'Wykres',
    audienceUnit: 'osoby na koncie, stan dnia',
    deltaUnit: 'przyrost dzienny',
    // {series} = nazwa wybranego szeregu.
    label: 'Dzień po dniu: {series}',
    // Dzień, którego NIE ZMIERZYLIŚMY — w tabeli dla czytnika ekranu zamiast liczby.
    noSnapshot: 'bez migawki',
    toggleSeries: 'Pokaż lub ukryj {account}',
    table: 'Tabela wykresu',
  },
  sort: {
    title: 'Sortowanie',
    label: 'Kolejność listy postów',
    // {value} = ta sama pozycja menu, małą literą.
    trigger: 'Sortuj: {value}',
    date: 'Data publikacji',
  },
  // Cztery liczniki. Te same słowa niosą nagłówki kolumn, pary na 390 i kafle okna posta.
  counter: {
    c1: 'Obejrzenia',
    c2: 'Polubienia',
    c3: 'Komentarze',
    c4: 'Udostępnienia',
  },
  // Skróty nagłówków w oknie posta na 390; pełna nazwa zostaje dla czytnika ekranu.
  counterShort: {
    c1: 'Obejrz.',
    c2: 'Polub.',
    c3: 'Kom.',
    c4: 'Udost.',
  },
  // JEDEN klucz, dwa warianty: krótki przy sumie konta, pełny w oknie posta i w etykiecie
  // dla czytnika ekranu.
  updated: {
    short: 'aktualizacja {when}',
    full: 'ostatnia aktualizacja {when}',
  },
  // Reguła 31: „dziś 14:20”, „wczoraj 18:00”, „18 wrz, 18:00”, inny rok „18.09.2025”.
  // Docelowo wspólny format całego produktu — na razie mieszka tu (`components/stats/when.ts`).
  when: {
    today: 'dziś',
    yesterday: 'wczoraj',
  },
  stale: 'nieaktualne',
  reauth: {
    pill: 'zaloguj ponownie',
    action: 'Połącz ponownie',
  },
  cycle: {
    // Niedzieląca spacja przed „dni”, żeby etykieta nie łamała się w połowie.
    youtube: 'co 2-3 dni',
  },
  pending: 'jeszcze bez liczb',
  // {platformLoc} bierze się z istniejącej mapy `appAccounts.platformLoc`.
  open: 'Otwórz na {platformLoc}',
  post: {
    title: 'Post z {date}',
    daily: 'Dzień po dniu',
    day: 'Dzień',
    close: 'Zamknij',
    // Szewron wiersza na 390 otwiera arkusz posta — etykieta wyłącznie dla czytnika.
    openSheet: 'Pokaż liczby posta z {date}',
  },
  more: 'Załaduj więcej',
  listLabel: 'Posty z liczbami',
  totalsLabel: 'Sumy kont w tym zakresie',
  empty: {
    noAccounts: {
      title: 'Brak podłączonych kont',
      action: 'Podłącz konto',
    },
    noPosts: {
      title: 'Brak publikacji',
      action: 'Zaplanuj publikację',
    },
  },
  error: {
    title: 'Nie udało się wczytać statystyk.',
    retry: 'Spróbuj ponownie',
  },
  // 46-A (paczka PS): pierścień utworu do NASTĘPNEGO progu. Teksty z `copy/*.txt` sesji A.
  // Zero zdań objaśniających (reguła 8): widać dane, pełna treść idzie do czytnika (`aria*`).
  // Liczby wstawia ekran już sformatowane (spacja nierozdzielająca, reguła 39).
  tracks: {
    title: 'Utwory',
    toNext: 'do {threshold}: {left}',
    aria: '{count} obejrzeń, do {threshold} zostało {left}',
    ariaTop: '{count} obejrzeń',
    ariaHit: 'próg {threshold} obejrzeń osiągnięty',
  },
  // Karta jednorazowa osiągniętego progu (klatka 01b): liczba progu stoi w pigułce obok.
  milestone: {
    label: 'obejrzeń pod „{track}”',
    show: 'Pokaż',
  },
  // Karta podsumowania zamkniętego miesiąca (klatka 01c). Tytuł w mianowniku („Wrzesień”),
  // suma z miejscownikiem z przyimkiem („we wrześniu”) — dwie listy po 12.
  month: {
    total: 'Obejrzenia {inMonth}',
    // Porównanie z poprzednim miesiącem: dopełniacz z przyimkiem (jak w Powiadomieniach).
    vs: {
      m1: 'wobec stycznia', m2: 'wobec lutego', m3: 'wobec marca', m4: 'wobec kwietnia', m5: 'wobec maja', m6: 'wobec czerwca',
      m7: 'wobec lipca', m8: 'wobec sierpnia', m9: 'wobec września', m10: 'wobec października', m11: 'wobec listopada', m12: 'wobec grudnia',
    },
    record: 'najlepszy miesiąc do tej pory',
    topTrack: 'Najczęściej oglądany utwór',
    quoted: '„{track}”',
    nextRing: 'Do {threshold} pod „{track}”',
    left: 'zostało {left}',
    name: {
      m1: 'Styczeń', m2: 'Luty', m3: 'Marzec', m4: 'Kwiecień', m5: 'Maj', m6: 'Czerwiec',
      m7: 'Lipiec', m8: 'Sierpień', m9: 'Wrzesień', m10: 'Październik', m11: 'Listopad', m12: 'Grudzień',
    },
    in: {
      m1: 'w styczniu', m2: 'w lutym', m3: 'w marcu', m4: 'w kwietniu', m5: 'w maju', m6: 'w czerwcu',
      m7: 'w lipcu', m8: 'w sierpniu', m9: 'we wrześniu', m10: 'w październiku', m11: 'w listopadzie', m12: 'w grudniu',
    },
  },
  // Drabinka startu (klatka 04): konto bez żadnej publikacji. Stan kroku niesie pierścień;
  // słowo stanu jest wyłącznie dla czytnika ekranu.
  ladder: {
    label: 'Start publikacji',
    connected: 'Konto połączone',
    firstPost: 'Pierwsza publikacja',
    firstThreshold: 'Pierwsze {threshold} obejrzeń pod utworem',
    done: 'zrobione',
    todo: 'jeszcze nie',
  },
}
